var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoMirth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 173.2 173.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: none;\n        stroke: #111732;\n        stroke-miterlimit: 10;\n        stroke-width: 1.1px;\n      }\n\n      .st1 {\n        fill: #0b1632;\n      }\n\n      .st2 {\n        fill: #111732;\n      }\n\n      .st3 {\n        fill: #33ffdb;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M0,159.3V13.9C0,6.2,6.2,0,13.8,0h145.3c7.6,0,13.8,6.2,13.8,13.9v145.5c0,7.7-6.2,13.9-13.8,13.9H13.8C6.2,173.2,0,167,0,159.3Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M149.3,70.3c-1.2-4.5-5.7-7.2-10.2-6-3.7,1-6.1,4.2-6.2,7.9l-26.9,7c.3.7.5,1.4.7,2.2.2.8.3,1.5.4,2.3l26.9-7c1.8,3.1,5.6,4.8,9.3,3.9,4.5-1.2,7.2-5.7,6-10.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M65.9,89.5l-19.7,5.1c-2.2-4.6-7.4-7.1-12.5-5.8-5.8,1.5-9.3,7.5-7.8,13.3,1.5,5.8,7.5,9.4,13.3,7.8,5-1.3,8.3-5.9,8.2-10.9l19.8-5.1c-.3-.7-.5-1.4-.7-2.2-.2-.8-.3-1.5-.4-2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M99.1,49.5c1.1,0,2.2,0,3.4-.3,5.8-1.5,9.3-7.5,7.8-13.3-1.5-5.8-7.5-9.4-13.3-7.8s-9.3,7.5-7.8,13.3c.8,3.1,2.9,5.5,5.5,6.9l-4.9,17.7c1.5.2,3,.7,4.4,1.2l4.9-17.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M73.6,70.2l-22.4-22.8c1-1.8,1.4-4,.8-6.2-1.2-4.5-5.7-7.2-10.2-6-4.5,1.2-7.2,5.7-6,10.2,1.2,4.5,5.7,7.2,10.2,6,.7-.2,1.3-.4,1.9-.8l22.4,22.9c1-1.2,2.1-2.3,3.3-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M99.3,103l22.7,23.2c-2.8,4.3-2.3,10.1,1.4,13.8,4.3,4.2,11.2,4.2,15.4,0s4.2-11.2,0-15.5c-3.7-3.6-9.3-4.1-13.5-1.4l-22.8-23.2c-1,1.2-2.1,2.3-3.3,3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M73.6,124.4c-3.7,0-7,2.5-8,6.2-1.2,4.5,1.5,9.1,5.9,10.3,4.5,1.2,9.1-1.5,10.2-5.9,1-3.7-.7-7.4-3.7-9.3l5.1-18.5c-1.5-.2-3-.7-4.4-1.3l-5.1,18.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M99.3,80.9l6.6-1.7c-2.1-5.6-6.5-9.8-11.7-11.9l-1.8,6.6c-1.2,4.2,2.7,8.2,6.9,7.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M85,100.6l-1.8,6.6c2.8.4,5.7.4,8.5-.4,2.9-.7,5.4-2.1,7.6-3.8l-4.8-4.9c-3.1-3.1-8.4-1.8-9.6,2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M97.8,94.9l4.8,4.9c3.6-4.4,5.3-10.2,4.5-16.1l-6.6,1.7c-4.3,1.1-5.7,6.4-2.6,9.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M75.1,78.3l-4.7-4.8c-3.6,4.4-5.3,10.2-4.5,16.1l6.6-1.7c4.3-1.1,5.7-6.4,2.6-9.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M73.6,92.3l-6.6,1.7c2.1,5.6,6.4,9.8,11.7,11.9l1.8-6.5c1.2-4.2-2.7-8.2-6.9-7.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M87.9,72.6l1.8-6.6c-2.8-.4-5.6-.3-8.5.4-2.9.7-5.5,2.1-7.7,3.8l4.8,4.8c3.1,3.1,8.4,1.8,9.6-2.5Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMirth);
export default __webpack_public_path__ + "static/media/Logo_Mirth.76b470ea2960937c2b67c8f680479d0a.svg";
export { ForwardRef as ReactComponent };